import { truncateString } from "@/utils";
import FilterItem from "./FilterItem.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
import BrandFilterBody from "./bodies/BrandFilterBody.vue";
export default {
  name: "BrandFilter",
  components: {
    FilterItem,
    BrandFilterBody
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    brands: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    }
  },
  computed: {
    getBrandJoined() {
      return this.brands.selected.map(el => el?.brand).join(", ");
    },
    getBrandTitle() {
      return truncateString(this.getBrandJoined.length > 0 ? this.getBrandJoined : 'Brand', 16);
    },
    getBrandSelectedTitle() {
      return this.getBrandJoined.length > 0 ? truncateString(this.getBrandJoined, 200) : "";
    }
  },
  methods: {
    handleBrandSearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.brands.searching = false;
      }
      this.brands.listSearch(value, ['brand']);
    },
    handleClear() {
      this.brands.clear();
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.brands.clearDraft();
    },
    onHidden() {
      this.brands.clearDraft();
    },
    onRestoreSearch() {
      this.brands.restoreSearch();
    },
    handleSelect({
      id
    }) {
      this.brands.select({
        id
      }, 'id');
    },
    handleSelectOnly({
      id
    }) {
      this.brands.selectOnly({
        id
      }, 'id');
    },
    handleDeselect({
      id
    }) {
      this.brands.deselect({
        id
      }, 'id');
    },
    handleClearAll() {
      this.brands.clear();
      this.$emit('cleared');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.brandFilterItem, initializer, callback);
    }
  }
};